import CloseIcon from '@mui/icons-material/Close';
import {
  Box, Dialog, DialogContent, DialogTitle, IconButton, Typography,
} from '@mui/material';
import React from 'react';
import VimeoPreview from '../vimeo-preview';

interface VimeoModalProps {
  open: boolean;
  onClose: () => void;
  url: string;
  title?: string;
}

const VimeoModal: React.FC<VimeoModalProps> = ({
  open, onClose, url, title,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: 2,
        overflow: 'hidden',
      },
    }}
  >
    <DialogTitle
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pb: 1,
      }}
    >
      <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
        {title || 'Vimeo Video'}
      </Typography>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent sx={{ p: 0 }}>
      <Box
        sx={{
          width: '100%',
          height: 400,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <VimeoPreview
          url={url}
          width="100%"
          height="100%"
          showControls
          style={{
            borderRadius: 0,
          }}
        />
      </Box>
    </DialogContent>
  </Dialog>
);

export default VimeoModal;

VimeoModal.defaultProps = {
  title: undefined,
};
